import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Works } from '../models/works';
import { Locations } from '../models/locations';

@Injectable({
  providedIn: 'root'
})

export class LocationsService extends CrudService<Locations, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/location`);

    this._http = _http;
  }

}

